import { InputDateComponent } from './input-date.component';

export default angular
  .module('sfMobile.components.input-date', [
    'sfMobile.services.gestures',
    'sfMobile.services.platform',
  ])
  .component('sfInputDate', InputDateComponent).name;
